export default __webpack_public_path__ + "static/media/2013.fed8c156.png";